import * as z from "zod";
import AddressTypeEnum from "@/constants/enums/AddressTypeEnum";

const addressTypeValues = Object.values(AddressTypeEnum) as [string, ...string[]];

export const addressTypeSchema = z.enum(addressTypeValues, {
  errorMap: () => ({ message: "validation:addressTypeRequired" }),
});

export type AddressType = z.infer<typeof addressTypeSchema>;
